export const getTransactionAmountProperty = (type) => {
  const transactionTypeMap = {
    income: 'credit_amount',
    loan: 'debit_amount',
  };

  if (type in transactionTypeMap) {
    return transactionTypeMap[type];
  } else {
    throw new Error(`Invalid transaction amount type: ${type}`);
  }
};

export const getTransactionTotalsProperty = (type) => {
  const transactionTypeMap = {
    income: 'credits_total',
    loan: 'debits_total',
  };

  if (type in transactionTypeMap) {
    return transactionTypeMap[type];
  } else {
    throw new Error(`Invalid transaction total type: ${type}`);
  }
};

export const normalizeText = (string) => {
  return string
    .split('_')
    .map(function (word) {
      if (word === 'AND') {
        return '&';
      } else {
        return `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`;
      }
    })
    .join(' ');
};

export const externalDoughnutPlugin = {
  id: 'emptyDoughnut',
  afterDraw(chart, args, options) {
    const { datasets } = chart.data;
    const { color, width, radiusDecrease } = options;
    let hasData = false;

    for (const dataset of datasets) {
      hasData |= dataset.data.length > 0;
    }

    if (!hasData) {
      const {
        chartArea: { left, top, right, bottom },
        ctx,
      } = chart;
      const centerX = (left + right) / 2;
      const centerY = (top + bottom) / 2;
      const r = Math.min(right - left, bottom - top) / 2;

      ctx.beginPath();
      ctx.lineWidth = width || 2;
      ctx.strokeStyle = color || 'rgba(255, 128, 0, 0.5)';
      ctx.arc(centerX, centerY, r - radiusDecrease || 0, 0, 2 * Math.PI);
      ctx.stroke();
    }
  },
};
